import { render, staticRenderFns } from "./OrderItemsByIdToggle.vue?vue&type=template&id=303ae8cc&scoped=true"
import script from "./OrderItemsByIdToggle.vue?vue&type=script&lang=js"
export * from "./OrderItemsByIdToggle.vue?vue&type=script&lang=js"
import style0 from "./OrderItemsByIdToggle.vue?vue&type=style&index=0&id=303ae8cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303ae8cc",
  null
  
)

export default component.exports